<template>
  <i class="clubOptionIcon">
    <svg v-if="icon==='1'" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M10.3207 0.00012207H0.991061C0.442812 0.00012207 0 0.442948 0 0.991197V10.3208C0 10.8691 0.442812 11.3119 0.991061 11.3119H10.3207C10.8689 11.3119 11.3117 10.8691 11.3117 10.3208V0.991197C11.3117 0.442948 10.8689 0.00012207 10.3207 0.00012207Z"
          fill="white"/>
    </svg>
    <svg v-else-if="icon==='2'" width="22" height="23" viewBox="0 0 22 23" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M10.3207 0.00012207H0.991061C0.442812 0.00012207 0 0.442948 0 0.991197V10.3208C0 10.8691 0.442812 11.3119 0.991061 11.3119H10.3207C10.8689 11.3119 11.3117 10.8691 11.3117 10.3208V0.991197C11.3117 0.442948 10.8689 0.00012207 10.3207 0.00012207Z"
          fill="#96E77D"/>
      <path
          d="M20.9091 10.8456H11.6311C11.0688 10.8456 10.6143 11.3001 10.6143 11.8624V21.1405C10.6143 21.7028 11.0688 22.1573 11.6311 22.1573H20.9091C21.4714 22.1573 21.926 21.7028 21.926 21.1405V11.8624C21.926 11.3001 21.4714 10.8456 20.9091 10.8456Z"
          fill="#96E77D"/>
    </svg>
    <svg v-else-if="icon==='3'" width="33" height="23" viewBox="0 0 33 23" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M10.3207 0.00012207H0.991061C0.442812 0.00012207 0 0.442948 0 0.991197V10.3208C0 10.8691 0.442812 11.3119 0.991061 11.3119H10.3207C10.8689 11.3119 11.3117 10.8691 11.3117 10.3208V0.991197C11.3117 0.442948 10.8689 0.00012207 10.3207 0.00012207Z"
          fill="#E9E9E9"/>
      <path
          d="M31.4654 0H22.1452C21.5946 0 21.1494 0.445159 21.1494 0.995751V10.316C21.1494 10.8666 21.5946 11.3117 22.1452 11.3117H31.4654C32.016 11.3117 32.4612 10.8666 32.4612 10.316V0.995751C32.4612 0.445159 32.016 0 31.4654 0Z"
          fill="#E9E9E9"/>
      <path
          d="M20.9082 10.8456H11.6301C11.0678 10.8456 10.6133 11.3001 10.6133 11.8624V21.1405C10.6133 21.7028 11.0678 22.1573 11.6301 22.1573H20.9082C21.4705 22.1573 21.925 21.7028 21.925 21.1405V11.8624C21.925 11.3001 21.4705 10.8456 20.9082 10.8456Z"
          fill="#E9E9E9"/>
    </svg>
    <svg v-else-if="icon==='4'" width="43" height="23" viewBox="0 0 43 23" fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path
          d="M10.3207 0.00012207H0.991061C0.442812 0.00012207 0 0.442948 0 0.991197V10.3208C0 10.8691 0.442812 11.3119 0.991061 11.3119H10.3207C10.8689 11.3119 11.3117 10.8691 11.3117 10.3208V0.991197C11.3117 0.442948 10.8689 0.00012207 10.3207 0.00012207Z"
          fill="#E9E9E9"/>
      <path
          d="M31.4654 0H22.1452C21.5946 0 21.1494 0.445159 21.1494 0.995751V10.316C21.1494 10.8666 21.5946 11.3117 22.1452 11.3117H31.4654C32.016 11.3117 32.4612 10.8666 32.4612 10.316V0.995751C32.4612 0.445159 32.016 0 31.4654 0Z"
          fill="#E9E9E9"/>
      <path
          d="M20.9082 10.8456H11.6301C11.0678 10.8456 10.6133 11.3001 10.6133 11.8624V21.1405C10.6133 21.7028 11.0678 22.1573 11.6301 22.1573H20.9082C21.4705 22.1573 21.925 21.7028 21.925 21.1405V11.8624C21.925 11.3001 21.4705 10.8456 20.9082 10.8456Z"
          fill="#E9E9E9"/>
      <path
          d="M41.9998 10.8456H32.6889C32.136 10.8456 31.6885 11.2931 31.6885 11.846V21.1569C31.6885 21.7098 32.136 22.1573 32.6889 22.1573H41.9998C42.5527 22.1573 43.0002 21.7098 43.0002 21.1569V11.846C43.0002 11.2931 42.5527 10.8456 41.9998 10.8456Z"
          fill="#E9E9E9"/>
    </svg>
  </i>

</template>

<script>
export default {
  name: "ClubOptionIcon",

  props: {
    icon: {type: String, default: null, required: true}
  }
}
</script>


<style scoped lang="scss">

.clubOptionIcon {
  svg {
    height: 24px;
  }
}
</style>
